import api from './api';
import type {
  RenovacaoRule,
  RenovacaoRulePayload,
  RenovacaoHistoryResponse,
  RenovacaoHistoryQuery,
} from '@/types/renovacao';

export const renovacaoRuleService = {
  async getByClient(clientId: number): Promise<RenovacaoRule> {
    const result = await api.get(`/renovacao-rules/client/${clientId}`) as any;
    return result?.data ?? result;
  },

  async upsert(clientId: number, payload: RenovacaoRulePayload): Promise<RenovacaoRule> {
    const result = await api.put(`/renovacao-rules/client/${clientId}`, payload) as any;
    return result?.data ?? result;
  },

  async listHistory(
    clientId: number,
    query: RenovacaoHistoryQuery = {}
  ): Promise<RenovacaoHistoryResponse> {
    const params: Record<string, string> = {};
    if (query.since) params.since = query.since;
    if (query.page) params.page = String(query.page);
    if (query.limit) params.limit = String(query.limit);
    if (query.status) params.status = query.status;
    const result = await api.get(`/renovacao-rules/client/${clientId}/historico`, {
      params,
    }) as any;
    return result;
  },
};
